export default __webpack_public_path__ + "static/media/dc-wonder.970ba2d6.jpg";